import { Cari } from "./cari";
import { Rota } from "./rota";
import { Sube } from "./sube";

export class Lojistik {

    id:number;
    tarih: Date;
    mazotBazFiyati: number;
    aciklama: string;
    sube: Sube;
    subeId: number;
    cari: Cari;
    cariId: number;
    private pRotalar: Rota[];
    
  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);

    if (obj.sube != null) {
      this.sube = new Sube(obj.sube);
    }
  }

  public get rotalar(): Rota[] {
    return this.pRotalar;
  }

  public set rotalar(list: Rota[]) {
    if (list != null) {
      this.pRotalar = list.map(f => new Rota(f));
    }
  }
}
